import type { FC, PropsWithChildren } from 'react';

import { Container, Spacing, styled } from '@cofenster/web-components';

import { PageFooter } from './PageFooter';

const Page = styled('main')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: '100vh',
  '@supports (-webkit-touch-callout: none)': {
    minHeight: '-webkit-fill-available',
  },
  backgroundColor: theme.palette.brand.linen,
}));

export const PageWrapper: FC<PropsWithChildren> = ({ children, ...rest }) => {
  return (
    <Page {...rest}>
      <Spacing top={5}>
        <Container maxWidth="md">{children}</Container>
      </Spacing>
      <PageFooter />
    </Page>
  );
};
